import { restRequest } from "vrcore-dashboard/dist/Dashboard/redux/utilities";

export const SET_USER_POSITIONS = "SET_USER_POSITIONS";
export const SET_SELECTED_AREA = "SET_SELECTED_AREA";
export const SET_SELECTED_DEPARTMENT = "SET_SELECTED_DEPARTMENT";
export const SET_COPY_PASTE_EVENT = "SET_COPY_PASTE_EVENT";
export const SET_TRACK_ID = "SET_TRACK_ID";
export const SET_TEMP_USER_POSITIONS = "SET_TEMP_USER_POSITIONS";
export const SET_WEEK_COUNT = "SET_WEEK_COUNT";
export const SET_WEEK_START = "SET_WEEK_START";
export const GET_USERS = restRequest("GET_USERS");
export const GET_PLANNER_DETAILS = restRequest("GET_PLANNER_DETAILS");
export const SET_PLANNER_DETAILS = restRequest("SET_PLANNER_DETAILS");
export const REMOVE_PLANNER_DETAILS = restRequest("REMOVE_PLANNER_DETAILS");
export const GET_TEMPLATE = restRequest("GET_TEMPLATE");
export const SET_TEMPLATE = restRequest("SET_TEMPLATE");
export const APPLY_TEMPLATE = restRequest("APPLY_TEMPLATE");
export const GET_RAW_JOBPOSTINGS = restRequest("GET_RAW_JOBPOSTINGS");
export const SET_ACTIVE_JOBPOSTING = "SET_ACTIVE_JOBPOSTING";
export const SET_CLICKED_EVENT_SEGMENT = "SET_CLICKED_EVENT_SEGMENT";
export const SET_JOBPOSTING_DATES = restRequest("SET_JOBPOSTING_DATES");
export const SET_ARRANGED_JOBPOSTINGS = "SET_ARRANGED_JOBPOSTINGS";
export const SET_SELECTED_JOBPOSTING_ID = "SET_SELECTED_JOBPOSTING_ID";
export const GET_ROSTER_IS_LOCKED = restRequest("GET_ROSTER_IS_LOCKED");
export const SET_ROSTER_IS_LOCKED = restRequest("SET_ROSTER_IS_LOCKED");
export const GET_EQUIPMENT = restRequest("SET_ROSTER_IS_LOCKED");
export const GET_VEHICLES = restRequest("GET_VEHICLES");
export const GET_DEPARTMENTS = restRequest("GET_DEPARTMENTS");
export const GET_AREAS = restRequest("GET_AREAS");
